<script>
import headNav from "../components/headNav.vue";
import router from "../router";
import {login} from "../api/api";


export default {
  name: "login",
  components:{headNav},
  data(){
    return{
      email:'',
      password:'',
      slide: 0,
      sliding: null
    }
  },
  methods:{
    onSlideStart(slide) {
      this.sliding = true
    },
    onSlideEnd(slide) {
      this.sliding = false
    },
    go(name){
      router.push(
        {
          name
        }
      )
    },
    mes(message,type){
      this.$message({
        message,
        type
      });
    },
    submit(){
      let reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
      if(!reg.test(this.email) || this.email.trim() == ''){
        this.mes('Email is empty or incorrect','warning')
        return
      }
      if(this.password.trim() == ''){
        this.mes('password cannot be empty','warning')
        return
      }
      login({
        email:this.email,
        password:this.password
      }).then( res => {
        console.log(res,"打印res")
        if(res.data.status == 200){
          this.mes(res.data.message,'success')
          this.$store.dispatch('setUserInfo', res.data.data)
          setTimeout(() => {
            this.go('home')
          },1000)
        }else {
          this.mes(res.data.message,'error')
        }
      })
    },
  }
}
</script>

<template>
  <div>
<!--    <head-nav></head-nav>-->
    <section class="section">
      <div class="container">
        <b-carousel
          id="carousel-1"
          v-model="slide"
          :interval="4000"
          controls
          indicators
          background="#ababab"
          img-width="1024"
          img-height="480"
          style="text-shadow: 1px 1px 2px #333;"
          @sliding-start="onSlideStart"
          @sliding-end="onSlideEnd"
        >
          <!-- Text slides with image -->
          <b-carousel-slide
            caption="First slide"
            text="Nulla vitae elit libero, a pharetra augue mollis interdum."
            img-src="https://picsum.photos/1024/480/?image=52"
          ></b-carousel-slide>

          <!-- Slides with custom text -->
          <b-carousel-slide img-src="https://picsum.photos/1024/480/?image=54">
            <h1>Hello world!</h1>
          </b-carousel-slide>

          <!-- Slides with image only -->
          <b-carousel-slide img-src="https://picsum.photos/1024/480/?image=58"></b-carousel-slide>

          <!-- Slides with img slot -->
          <!-- Note the classes .d-block and .img-fluid to prevent browser default image alignment -->
          <b-carousel-slide>
            <template #img>
              <img
                class="d-block img-fluid w-100"
                width="1024"
                height="480"
                src="https://picsum.photos/1024/480/?image=55"
                alt="image slot"
              >
            </template>
          </b-carousel-slide>

          <!-- Slide with blank fluid image to maintain slide aspect ratio -->
          <b-carousel-slide caption="Blank Image" img-blank img-alt="Blank image">
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse eros felis, tincidunt
              a tincidunt eget, convallis vel est. Ut pellentesque ut lacus vel interdum.
            </p>
          </b-carousel-slide>
        </b-carousel>

        <div class="row justify-content-center align-items-center">
          <div class="col-lg-6">
            <div class="shadow rounded p-5 bg-white">
              <div class="row">
                <div class="col-12 mb-4">
                  <h4>login</h4>
                </div>
                <div class="col-lg-12">
                  <div class="contact-form">
                      <div class="form-group mb-4 pb-2">
                        <label for="exampleFormControlInput1" class="form-label">Email address</label>
                        <input v-model="email" type="email" class="form-control shadow-none">
                      </div>
                      <div class="form-group">
                        <label for="exampleFormControlInput1" class="form-label">Email password</label>
                        <input v-model="password" type="password" class="form-control shadow-none">
                      </div>
                      <div class="form-group mb-4 pb-2">
                        <div style="display: flex;justify-content: space-between">
                          <div class="register" style="float: right" @click="go('forgotPassword')">forgot password</div>
                          <div class="register" style="float: right" @click="go('register')">register</div>
                        </div>
                      </div>
                      <div style="height: 20px"></div>
                      <button class="btn btn-primary w-100" @click="submit">log on</button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>
@import "../../css/style.css";
.register:hover{
  color:#2080E4;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/view/login.vue